var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardLayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 376,
    height: 330,
    viewBox: "0 0 376 330",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 376,
    height: 330,
    rx: 10,
    fill: "#387CFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardLayer);
export default __webpack_public_path__ + "static/media/dashboard-layer.9614d4fe44be6576e741b7bfe93d612f.svg";
export { ForwardRef as ReactComponent };